<template>
  <div class="panel panel-body">
    <general-stepper
      :steps-info="stepsInfo"
      :enable-save-button="enableSaveButton"
      @finish="saveClassificationConfig"
      @changeStep="changeStep"
    >
      <template
        slot="content-step-1"
        class="col-xs-12"
      >
        <model-select
          v-model="modelComponentValues"
          :errors="errors"
          :disabled="isEditing"
          @canFinishStep="finishStep(1)"
          @canNotFinishStep="notFinishStep(1)"
          @removeSelectedModel="modelComponentValues.model = []"
        />
      </template>

      <template
        slot="content-step-2"
        class="col-xs-12"
      >
        <classification-config
          v-model="classificationComponentValues"
          :model-values="modelComponentValues"
          :errors="errors"
          @canFinishStep="finishStep(2)"
          @canNotFinishStep="notFinishStep(2)"
        />
      </template>
    </general-stepper>
  </div>
</template>

<script>
import ModelSelect from '@/employees/components/ClassificationConfig/ModelSelect'
import ClassificationConfig from '@/employees/components/ClassificationConfig/ClassificationConfig'
import { CLASSIFICATION_CONFIG_GROUP } from '@/constants'

export default {
  name: 'ClassificationConfigSteps',

  components: { ClassificationConfig, ModelSelect },

  props: {
    editData: {
      required: false,
      type: String,
      default: null,
    },
  },

  data () {
    return {
      enableSaveButton: false,
      isEditing: false,
      errors: {},

      modelComponentValues: {
        modelType: CLASSIFICATION_CONFIG_GROUP,
        model: [],
      },

      classificationComponentValues: {
        classificationConfig: null,
      },
    }
  },

  computed: {
    stepsInfo () {
      return this.$store.state.steps.steps_info
    },
  },

  watch: {
    modelComponentValues (newValue) {
      this.modelComponentValues.modelType = newValue.modelType
      this.modelComponentValues.model = newValue.model
    },

    classificationComponentValues (newValue) {
      this.classificationComponentValues.classificationConfig = newValue.classificationConfig
    },
  },

  created () {
    this.$store.dispatch('add_steps_info', {
      1: {
        step: 1,
        title: Lang.get('subscription.classification_config.select_type'),
        finished: false,
      },
      2: {
        step: 2,
        title: Lang.get('subscription.classification_config.create_classification'),
        finished: false,
      },
    },
    ).then(() => {
      this.$store.dispatch('set_active_step', { step: 1 })

      if (this.editData != null) {
        this.isEditing = true

        let editData = JSON.parse(this.editData)

        this.modelComponentValues = {
          modelType: editData.modelType,
          model: [
            { id: editData.model, name: editData.modelName, program_id: editData.programId },
          ],
        }

        this.classificationComponentValues = {
          classificationConfig: JSON.stringify(editData.classificationConfig),
        }

        this.finishStep(1)
        this.finishStep(2)
      }
    })
  },

  methods: {
    changeStep (event) {
      this.$store.dispatch('set_active_step', { step: event.step })
    },

    finishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: true })
    },

    notFinishStep (stepNumber) {
      return this.$store.dispatch('update_step_finished', { step: stepNumber, finished: false })
    },

    saveClassificationConfig () {
      // disable the save button while creating/updating
      this.enableSaveButton = false
      this.errors = {}

      if (this.isEditing) {
        let params = {
          data: this.classificationComponentValues.classificationConfig,
        }

        axios.put(`/admin/classification-configs/${JSON.parse(this.editData).id}`, params, { errorHandle: false }).then((response) => {
          window.location.href = response.data.redirect
        }).catch((error) => {
          this.errors = error.response.data.data

          this.enableSaveButton = true
        })
      } else {
        let params = {
          model_type: this.modelComponentValues.modelType,
          model: this.modelComponentValues.model.map(model => model.id),
          data: this.classificationComponentValues.classificationConfig,
        }

        axios.post('/admin/classification-configs', params, { errorHandle: false }).then((response) => {
          window.location.href = response.data.redirect
        }).catch((error) => {
          this.errors = error.response.data.data

          this.enableSaveButton = true
        })
      }
    },
  },
}
</script>

<style>
    .v-stepper {
        margin-bottom: 15px;
    }
</style>
